"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import style from "../../../style.module.css";
import { tabIcons } from "@/shared/constants/icons";
import { cn } from "@/shared/libs/commonUtils";
import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import Grid from "@/shared/components/common/Grid";
import { useDeviceType } from "@/shared/context/DeviceContext";

export interface TabItemProps {
  title: string;
  icon: string;
  link: string;
}

export default function TabItem({ icon, link, title }: TabItemProps) {
  const pathname = usePathname();
  const tab = pathname.substring(0, pathname.length - 1);
  const device = useDeviceType();

  return (
    <Grid.GridCol
      key={title}
      className={cn(
        style.tab,
        `max-md:h-full !py-7 ${
          tab === link &&
          "md:text-primary max-md:hover:!text-background sm:border-b-4 sm:border-primary md:[&_svg]:fill-primary"
        } ${
          !tab &&
          link === "/" &&
          "md:text-primary sm:border-b-4 sm:border-primary md:[&_svg]:fill-primary"
        }`,
      )}
    >
      <Link href={link} className="w-full">
        {device === "desktop" ? (
          <Flex className="max-md:flex-col items-center md:justify-center gap-x-2 max-md:gap-1">
            {tabIcons[icon]}
            <Flex className="items-center gap-x-1">
              <Typography className={cn(style.font, "max-md:text-center")}>
                {title}
              </Typography>
            </Flex>
          </Flex>
        ) : (
          <Flex className="max-md:flex-col items-center md:justify-center gap-x-2 max-md:gap-1 p-2 px-5 border border-foreground rounded-md bg-background">
            {tabIcons[icon]}
            <Flex className="items-center gap-x-1">
              <Typography className={cn(style.font, "max-md:text-center")}>
                {title}
              </Typography>
            </Flex>
          </Flex>
        )}
      </Link>
    </Grid.GridCol>
  );
}
